const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof filesystem !== "undefined") return resolve();
	__webpack_require__.l("https://media.acreiq.com/varRemoteEntry.js", (event) => {
		if(typeof filesystem !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "filesystem");
}).then(() => (filesystem));